import { useAppDispatch } from "@/redux/hooks";
import { openSnackbarAction } from "@/redux/slices";
import { routes } from "@/routes/utils";
import { useGetSubModules } from "@/services/masterData";
import moment from "moment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
 import { useMemo } from "react";

const useSubmodule = () => {
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const dispatch = useAppDispatch();

  const queryParams = useMemo(() => ({
    ...(filterData || {}),
    page: pageNumber + 1,
    orderBy: "createdAt",
    orderDirection: "DESC",
    limit: pageSize,
  }), [filterData, pageNumber, pageSize]);

  const { data: response, isPending, isError } = useGetSubModules(queryParams, {
  onError: (err) => {
    console.error("Error fetching sub modules:", err);
    dispatch(openSnackbarAction({
      message: "Failed to fetch sub modules ❌",
      severity: "error",
    }));
  },
});

  const tableData = response?.data?.[0]?.records || [];
  const totalRecords = response?.data?.[0]?.pagination?.[0]?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // Define Table Columns
  const columns = [
    {
      accessorKey: "grade",
      header: <div>Sub Module Name</div>,
      cell: (row: any) => (
        <span
          className="text-primary font-normal hover:cursor-pointer"
          onClick={() => onGradClick(row?.row?.original)}
        >
          {String(row?.row?.original?.sub_module_name || "")}
        </span>
      ),
      size: 80,
    },
    {
      accessorKey: "module",
      header: <div>Module</div>,
      accessorFn: (row: any) => String(row?.module_name || ""),
      size: 80,
    },
    {
      accessorKey: "submoduleName",
      header: <div>Grade</div>,
      accessorFn: (row: any) => String(row?.curriculum_grade || ""),
    },
    {
      accessorKey: "createdAt",
      header: <div>Created On</div>,
      accessorFn: (row: any) =>
        moment(row?.createdAt).format("DD-MM-YYYY") || "",
    },
  ];

  const onAdd = () => {
    navigate(`${routes.submodule}/${routes.add}`);
  };

  const onGradClick = (row: any) => {
    const id = row?.sub_module_id || row?.subModuleId || row?.id;
    navigate(`${routes.submodule}/${id}/${routes.edit}`, { state: row });
  };

  const onCancelFilter = () => {
    setOpenFilter(false);
  };

  const onFilterBtnClick = () => {
    setOpenFilter(true);
  };

  return {
    columns,
    onAdd,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    isPending,
    isError,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
  };
};

export default useSubmodule;
